import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import useMergeProps from '../../../../hooks/useMergeProps';
import { StateType } from '../../../../states';

import MissionFreebetsPotentialGain from './MissionFreebetsPotentialGain';
import selectMissionFreebetsPotentialGainContainerProps from './MissionFreebetsPotentialGain.selector';

type MissionFreebetsPotentialGainContainerProps = {
  className?: string;
  missionId: number;
  smallIcon?: boolean;
};

const MissionFreebetsPotentialGainContainer = ({
  missionId,
  ...ownProps
}: MissionFreebetsPotentialGainContainerProps) => {
  const selectorProps = useMemo(() => ({ missionId }), [missionId]);
  const selectedProps = useSelector((state: StateType) =>
    selectMissionFreebetsPotentialGainContainerProps(state, selectorProps),
  );

  const enhancedProps = useMergeProps({ ownProps, selectedProps });
  return <MissionFreebetsPotentialGain {...enhancedProps} />;
};

export default MissionFreebetsPotentialGainContainer;
